export const MEDIA_TRACK_KINDS = {
	audio: "audio",
	video: "video",
} as const;

export type MediaTrackKind =
	(typeof MEDIA_TRACK_KINDS)[keyof typeof MEDIA_TRACK_KINDS];

export const MEDIA_TRACK_PRELOAD_STATUSES = {
	idle: "idle",
	loading: "loading",
	ready: "ready",
	error: "error",
} as const;

export type MediaTrackPreloadStatus =
	(typeof MEDIA_TRACK_PRELOAD_STATUSES)[keyof typeof MEDIA_TRACK_PRELOAD_STATUSES];

export interface MediaTrackDescriptor {
	src: string;
	durationMs: number;
	posterUrl?: string | null;
}

export interface SegmentMediaBundle {
	segmentId: string;
	audio?: MediaTrackDescriptor;
	video?: MediaTrackDescriptor;
}

export interface MediaTrackState {
	segmentId: string;
	kind: MediaTrackKind;
	src: string | null;
	preloadStatus: MediaTrackPreloadStatus;
	bufferedPercent: number;
	isReadyForPlayback: boolean;
	durationMs: number | null;
}

export function mediaTrackStateKey(
	segmentId: string,
	kind: MediaTrackKind,
): string {
	return `${segmentId}:${kind}`;
}
